<template>
    <div class="print-well-detail">
        <div class="well-credentials">
            <div>{{ selectedSlide.esId }}</div>
            &nbsp;|&nbsp;
            <well-embryo-id-view class="responsive" :well="focusedWell" />
        </div>
        &nbsp;|&nbsp;
        <div class="well-event">
            <well-last-event :well="focusedWell" mode="simple" />
        </div>
    </div>
</template>

<script>
import WellEmbryoIdView from '../common/WellEmbryoIdView'
import WellLastEvent from '../common/WellLastEvent'
import { mapState } from 'vuex'
export default {
    name: 'PrintWellDetail',
    components: { WellLastEvent, WellEmbryoIdView },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell,
            selectedSlide: state => state.timelapse.selectedSlide
        })
    }
}
</script>

<style lang="scss">
.print-well-detail {
    display: flex;

    .well-credentials {
        display: flex;

        .well-id,
        .well-embryo-id-view {
            color: $black !important;
        }
    }
    .well-event {
        .event-label,
        .value {
            color: $black !important;
        }
    }
}
</style>